"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformV2IssueSubtypeToGGIssueType = exports.IssueTypeMigration = exports.IssueTypeCategoryMigration = void 0;
var _omit = _interopRequireDefault(require("lodash/omit"));
var _identity = _interopRequireDefault(require("lodash/identity"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const transformV2IssueSubtypeToGGIssueType = v2IssueSubtype => ({
  ...(0, _omit.default)(v2IssueSubtype, ["issueTypeId"]),
  issueTypeCategoryId: v2IssueSubtype.issueTypeId
});
exports.transformV2IssueSubtypeToGGIssueType = transformV2IssueSubtypeToGGIssueType;
const IssueTypeCategoryMigration = exports.IssueTypeCategoryMigration = {
  serialize: _identity.default,
  deserialize: v2IssueType => ({
    ...(0, _omit.default)(v2IssueType, ["subtypes", "statusSet", "containerId"]),
    projectId: v2IssueType.containerId,
    types: v2IssueType.subtypes.map(transformV2IssueSubtypeToGGIssueType)
  })
};
const IssueTypeMigration = exports.IssueTypeMigration = {
  serialize: _identity.default,
  deserialize: v2IssueSubtype => ({
    ...(0, _omit.default)(v2IssueSubtype, ["issueTypeId"]),
    issueTypeCategoryId: v2IssueSubtype.issueTypeId
  })
};
//# sourceMappingURL=IssueTypeMigration.js.map